(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-story-vault]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const controls = root.querySelector('[data-vault-controls]');
      const search = root.querySelector('[data-vault-search]');
      const collection = root.querySelector('[data-vault-collection]');
      const counter = root.querySelector('[data-vault-count]');
      const more = root.querySelector('[data-vault-more]');
      const empty = root.querySelector('[data-vault-empty]');
      const normalize = text => text.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[’‘]/g, "'");
      const items = [...root.querySelectorAll('[data-vault-item]')].map(element => ({element, title: normalize(element.dataset.title)}));
      if (root.dataset.filtered) {
        const words = {one: 1, two: 2, three: 3, four: 4, five: 5, six: 6, seven: 7, eight: 8, nine: 9, ten: 10, eleven: 11, twelve: 12};
        const chapter = title => {
          const match = title.match(/\bchapter\s+(\d+|one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve)\b/i);
          return match ? (Number(match[1]) || words[match[1].toLowerCase()]) : null;
        };
        if (items.every(item => chapter(item.title) !== null)) {
          items.sort((a, b) => chapter(a.title) - chapter(b.title));
          items.forEach(item => root.querySelector('#vault-stories').append(item.element));
        }
      }
      let limit = 12;
      const render = () => {
        const query = normalize(search.value.trim());
        const matches = items.filter(item => item.title.includes(query));
        const visible = new Set(matches.slice(0, limit).map(item => item.element));
        items.forEach(item => { item.element.hidden = !visible.has(item.element); });
        counter.textContent = counter.dataset.countTemplate.replace('[shown]', String(visible.size)).replace('[total]', String(matches.length));
        empty.hidden = matches.length !== 0;
        more.hidden = matches.length <= limit;
      };
      search.addEventListener('input', () => { limit = 12; render(); });
      collection.addEventListener('change', () => { window.location.assign(collection.value); });
      more.addEventListener('click', () => {
        const previous = [...root.querySelectorAll('[data-vault-item]:not([hidden])')];
        limit += 12;
        render();
        const next = [...root.querySelectorAll('[data-vault-item]:not([hidden])')].find(item => !previous.includes(item));
        if (next) next.querySelector('a').focus({preventScroll: true});
      });
      root.querySelector('[data-vault-clear]').addEventListener('click', () => { search.value = ''; limit = 12; render(); search.focus(); });
      controls.hidden = false;
      render();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once: true});
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
